import { ProductOffer } from '@/api/backend/contract/ProductList';
import { UiKitButtonTab } from '@/ui-kit/button-tab';

import { styles } from './ProductVariantSelector.styles';

export interface ProductVariantSelectorProps {
  variants: ProductOffer[];
  selectedVariantId: string | null;
  onVariantClick: (variantId: string) => void;
}

export function ProductVariantSelector({
  variants,
  selectedVariantId,
  onVariantClick
}: ProductVariantSelectorProps) {
  const slots = styles();

  if (!variants || variants.length === 0) return null;

  return (
    <div className={slots.base()}>
      <div className={slots.options()}>
        {variants.map((variant) => (
          <UiKitButtonTab
            key={variant.uuid}
            active={variant.uuid === selectedVariantId}
            disabled={variant.totalStock <= 0}
            onClick={() => onVariantClick(variant.uuid)}
          >
            {variant.size}
          </UiKitButtonTab>
        ))}
      </div>
    </div>
  );
}
